import type { HealthStatus } from './types';

export const STATUS_LABEL: Record<HealthStatus, string> = {
  healthy: 'Healthy',
  degraded: 'Degraded',
  critical: 'Critical',
};

export function formatPct(n: number | null | undefined, digits = 0): string {
  if (n == null || Number.isNaN(n)) return '—';
  return `${n.toLocaleString('en-ZA', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}%`;
}

export function formatMs(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '—';
  return `${Math.round(n).toLocaleString('en-ZA')} ms`;
}

export function formatCount(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '—';
  return n.toLocaleString('en-ZA', { maximumFractionDigits: 0 });
}

export function formatBytes(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) return '—';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let v = n;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i += 1;
  }
  return `${v.toLocaleString('en-ZA', { maximumFractionDigits: v >= 10 ? 0 : 1 })} ${units[i]}`;
}

export function formatEnv(env: string): string {
  if (env === 'production') return 'Production';
  if (env === 'staging') return 'Staging';
  if (env === 'uat') return 'UAT';
  return env;
}

export function formatWhen(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('en-ZA', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}

export function statusClasses(status: HealthStatus): {
  text: string;
  bg: string;
  ring: string;
  dot: string;
} {
  if (status === 'critical') {
    return {
      text: 'text-red-700',
      bg: 'bg-red-50',
      ring: 'ring-red-100',
      dot: 'bg-red-600',
    };
  }
  if (status === 'degraded') {
    return {
      text: 'text-amber-800',
      bg: 'bg-amber-50',
      ring: 'ring-amber-100',
      dot: 'bg-amber-500',
    };
  }
  return {
    text: 'text-emerald-800',
    bg: 'bg-emerald-50',
    ring: 'ring-emerald-100',
    dot: 'bg-[var(--primary)]',
  };
}
